module.exports = __webpack_public_path__ + "img/20190523214311461.85b52904.jpg";